import { render } from "./Cv.vue?vue&type=template&id=53469fd8&scoped=true"
import script from "./Cv.vue?vue&type=script&lang=js"
export * from "./Cv.vue?vue&type=script&lang=js"

import "./Cv.vue?vue&type=style&index=0&id=53469fd8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Alexa\\OneDrive\\Bureau\\infolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53469fd8"]])

export default __exports__